import React from 'react';
import { hydrateRoot } from 'react-dom/client';

import App from './App/App';
import type { ClientContext } from './types';
import { configureGPTCallback } from './utils/gpt-utils';

export default async ({ site, locale, environment }: ClientContext) => {
  configureGPTCallback();
  hydrateRoot(
    document.getElementById('app') as Element,
    <App site={site} locale={locale} environment={environment} />,
  );
};
